import React from 'react';
import ToggleRow from './ToggleRow';

const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent";
const labelClass = "block text-sm font-medium text-gray-700 mb-1";

const DeliverySettingsCard = ({ settings, onToggle, onChange }) => (
  <div className="bg-white rounded-xl shadow p-6">
    <h3 className="font-semibold mb-4">配送方式</h3>
    <div className="space-y-4">
      <ToggleRow
        label="外送配送"
        description="开启后 H5 用户可选择外送"
        checked={!!settings.enable_delivery}
        onToggle={() => onToggle('enable_delivery')}
      />
      <ToggleRow
        label="到店自提"
        description="开启后 H5 用户可选择到店自提"
        checked={!!settings.enable_pickup}
        onToggle={() => onToggle('enable_pickup')}
        bordered
      />
    </div>

    {/* 以下运费/时效设置只在开启外送时才有意义 */}
    {!!settings.enable_delivery && (
      <div className="mt-5 pt-5 border-t border-gray-100 space-y-5">

        <div>
          <h4 className="text-sm font-semibold text-gray-600 mb-3">运费设置</h4>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className={labelClass}>免运费门槛 (USD)</label>
              <input
                type="number" step="0.01" min="0"
                className={inputClass}
                value={settings.free_shipping_threshold ?? ''}
                onChange={e => onChange('free_shipping_threshold', e.target.value)}
                placeholder="留空=不设免运费"
              />
            </div>
            <div>
              <label className={labelClass}>基础运费 (USD)</label>
              <input
                type="number" step="0.01" min="0"
                className={inputClass}
                value={settings.base_delivery_fee ?? ''}
                onChange={e => onChange('base_delivery_fee', e.target.value)}
                placeholder="留空=运费按0元"
              />
            </div>
          </div>
          <p className="text-xs text-gray-400 mt-1.5">
            订单商品小计达到免运费门槛时不收运费，否则收取基础运费。两项都留空则不收运费。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-gray-600 mb-3">
            立即送时效
            <span className="text-xs text-gray-400 font-normal ml-1">（预约送不受此限制）</span>
          </h4>
          <div className="grid grid-cols-2 gap-4 mb-3">
            <div>
              <label className={labelClass}>营业开始时间</label>
              <input
                type="time"
                className={inputClass}
                value={settings.business_hours_start || ''}
                onChange={e => onChange('business_hours_start', e.target.value)}
              />
            </div>
            <div>
              <label className={labelClass}>营业结束时间</label>
              <input
                type="time"
                className={inputClass}
                value={settings.business_hours_end || ''}
                onChange={e => onChange('business_hours_end', e.target.value)}
              />
            </div>
          </div>
          <p className="text-xs text-gray-400 mb-3">
            结束时间早于开始时间视为跨夜营业（如 22:00~02:00）。两项都留空表示不限制营业时间。
          </p>
          <ToggleRow
            label='开启"立即送"'
            description="临时关闭后，H5端只显示预约送（上午/下午/晚上），不显示立即送选项"
            checked={!!settings.enable_instant_delivery}
            onToggle={() => onToggle('enable_instant_delivery')}
            bordered
          />
        </div>

        <div>
          <h4 className="text-sm font-semibold text-gray-600 mb-3">预约送优惠</h4>
          <ToggleRow
            label="预约送免运费"
            description="开启后，客户选择预约送（非立即送）时一律免收运费，不受免运费门槛限制，用来引导客户多选预约送"
            checked={!!settings.free_shipping_for_scheduled}
            onToggle={() => onToggle('free_shipping_for_scheduled')}
          />
        </div>

      </div>
    )}
  </div>
);

export default DeliverySettingsCard;